import type { GridColDef, GridListViewColDef } from "@mui/x-data-grid-premium";
import { useMemo } from "react";
import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import type { DetailColumn, ReportColumn, ReportRow } from "../../../../api/types/widgetTypes";
import TabularReportListItemContent from "./TabularReportListItemContent";

const getRowHeight = () => "auto" as const;

const getColumnDefinitions = (columns: ReportColumn[]): GridColDef<ReportRow>[] =>
  columns.map((column) => ({
    field: column.id,
    headerName: column.title,
  }));

const getListViewColDef = (
  columns: ReportColumn[],
  columnsLimit: number | undefined,
  detailColumns: DetailColumn[] | undefined
): GridListViewColDef<ReportRow> => ({
  field: "listColumn",
  renderCell: (params) => (
    <TabularReportListItemContent
      row={params.row}
      columns={columns}
      columnsLimit={columnsLimit}
      detailColumns={detailColumns}
    />
  ),
});

interface Props {
  columns: ReportColumn[];
  rows: ReportRow[];
  columnsLimit?: number;
  loading?: boolean;
  detailColumns?: DetailColumn[];
}

const TabularReportList = ({ columns, rows, columnsLimit, loading, detailColumns }: Props) => {
  const gridColumns = useMemo(() => getColumnDefinitions(columns), [columns]);

  const listViewColDef = useMemo(
    () => getListViewColDef(columns, columnsLimit, detailColumns),
    [columns, columnsLimit, detailColumns]
  );

  return (
    <DataGrid<ReportRow>
      listView
      listViewColumn={listViewColDef}
      columns={gridColumns}
      rows={rows}
      loading={loading}
      getRowHeight={getRowHeight}
    />
  );
};

export default TabularReportList;
